/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import AccountOpeningProcess from "./account-opening-process";

export default AccountOpeningProcess;
